import React from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';

Delete.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleApprove: PropTypes.func.isRequired,
  labelCancel: PropTypes.string,
  labelApprove: PropTypes.string,
  content: PropTypes.string.isRequired,
};

const useStyles = makeStyles()((theme) => ({
  Root: {
    '& .MuiDialog-paper': {
      margin: theme.spacing(2, 4),
    },
  },
  CancelBtn: {
    margin: theme.spacing(1),
    border: '1px solid #989798 !important',
    color: '#989798',
  },
  ApproveBtn: {
    margin: theme.spacing(1),
    backgroundColor: '#75c31e !important',
    color: '#fff !important',
  },
  Title: {
    fontWeight: 600,
    display: 'flex',
    justifyContent: 'center',
    color: '#4a4a4a',
    paddingTop: theme.spacing(2),
  },
  DialogTitle: {
    backgroundColor: '#fff',
  },
  DialogContent: {
    backgroundColor: '#fff',
  },
  DialogAction: {
    backgroundColor: '#fff',
    justifyContent: 'center',
  },
}));

function Delete(props) {
  const { labelCancel = 'No', labelApprove = 'Yes', content, handleApprove, handleCancel, isOpen, isLoading } = props;
  const { classes } = useStyles();
  function handleOnCancel(e) {
    handleCancel(e);
  }

  function handleOnApprove(e) {
    handleApprove(e);
  }

  return (
    <Dialog open={isOpen ?? true} onClose={handleOnCancel} aria-labelledby="form-dialog-title" maxWidth="md" className={classes.Root}>
      <DialogTitle id="form-dialog-title" className={classes.DialogTitle}>
        <Typography variant="h" className={classes.Title}>
          CONFIRMATION
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.DialogContent}>{content}</DialogContent>
      <DialogActions className={classes.DialogAction}>
        <Button variant="outlined" color="primary" className={classes.CancelBtn} onClick={handleOnCancel}>
          {labelCancel}
        </Button>
        <Button variant="outlined" color="primary" className={classes.ApproveBtn} onClick={handleOnApprove} disabled={isLoading}>
          {isLoading && <CircularProgress size={14} style={{ marginRight: 10 }} />} {labelApprove}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default Delete;
